import _ from 'lodash'
import axios from 'axios'

// initial state
const state = {
  selectedSection: null,
  paginationPage: null,
  searchQuery: '',
  paginationCountInPage: 20,
  isDownload: false,
  currentCountDownload: 0,
  maxCountDownload: 3,
  isAuthorized: false,
  sections: [],
  items: []
}

// getters
const getters = {
  getSectionsTree: state => state.sections,
  getSectionById: (state, getters) => (id, sections) => {
    let section = null
    if (sections === undefined) {
      sections = state.sections
    }

    let find = _.find(sections, ['id', id])
    if (find !== undefined) {
      section = find
    } else {
      for (let i = 0; i < sections.length; i++) {
        let find = getters.getSectionById(id, sections[i].sections)
        if (find !== undefined) {
          section = find
          break
        }
      }
    }

    return section
  },
  getCurrentSection: state => state.selectedSection,
  getCurrentPaginationPage: state => state.paginationPage,
  getPaginationItemsInPage: state => state.paginationCountInPage,
  getSearchQuery: state => state.searchQuery,
  getCountItems: (state, getters) => {
    return getters.getFilteredItems.length
  },
  getFilteredItems: (state, getters) => {
    let items = []
    if (getters.getSearchQuery.length > 0) {
      items = _.filter(state.items, i => {
        let name = i.name.toLowerCase()
        let searchQuery = getters.getSearchQuery.toLowerCase()
        return name.indexOf(searchQuery) > -1
      })
    } else if (state.selectedSection === null) {
      items = state.items
    } else {
      items = _.filter(state.items, ['sectionId', state.selectedSection.id])
    }
    if (items === undefined) {
      items = []
    }
    return items
  },
  getRenderItems: (state, getters) => {
    let offset = (state.paginationPage - 1) * state.paginationCountInPage
    let counterRenderItems = 0
    let renderItems = []
    let filteredItems = getters.getFilteredItems
    for (let i = 0; i < filteredItems.length; i++) {
      if (i >= offset && counterRenderItems++ < state.paginationCountInPage) {
        renderItems.push(filteredItems[i])
      }
    }
    return renderItems
  },
  getIsDownload: state => state.isDownload,
  getIsAuthorized: state => state.isAuthorized,
  getCurrentCountDownload: state => state.currentCountDownload,
  getMaxCountDownload: state => state.maxCountDownload
}

// actions
const actions = {
  setSelectSection ({commit, state, getters}, payload) {
    commit('selectSection', payload)
    commit('simulateClickPageOne')
  },
  setSearchQuery ({commit}, payload) {
    commit('setSearchQuery', payload)
    commit('simulateClickPageOne')
  },
  async fillData ({commit}) {
    let res = await axios.get('/depository/getData')
    commit('setSections', res.data.sections)
    commit('setItems', res.data.files)
    commit('setCountDownload', res.data.countDownload)
  },
  async setCountDownload ({commit}, payload) {
    commit('setCountDownload', payload)
    await axios.post('/depository/setCountDownload', {countDownload: payload})
  }
}

// mutations
const mutations = {
  selectSection (state, payload) {
    state.selectedSection = payload
  },
  setPaginationPage (state, payload) {
    state.paginationPage = payload
  },
  setSearchQuery (state, payload) {
    state.searchQuery = payload
  },
  simulateClickPageOne () {
    let elem = document.querySelector('.el-pager>li')
    if (elem === null) {
      return
    }
    let evt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
    elem.dispatchEvent(evt)
  },
  setSections (state, payload) {
    state.sections = payload
  },
  setItems (state, payload) {
    state.items = payload
  },
  setCountDownload (state, payload) {
    state.currentCountDownload = payload
    state.isDownload = !(payload === null || payload >= state.maxCountDownload)
    state.isAuthorized = !(payload === null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/depository.js